import React, { Component } from 'react';
import { Spin } from 'antd';
import MyInput from 'components/controls/MyInput';
import Button from 'components/controls/Button';
import _validator from 'modules/validator';
import { routes } from 'routes/Routes';
import { GENERAL_ERROR_MESSAGE, SEND_EMAIL_SUCCESS, PROJECT_LOGO } from 'constants/constants';
import _notification from 'modules/notification';
import _authService from 'modules/AuthService';
import _branding from 'modules/branding';
// Phase C.5 (Candidate System UI Language Migration): moved off the legacy modules/i18n.js
// hardcoded-English+Marathi dictionary onto the centralized Text/dictionary.js architecture — see
// modules/i18n/dictionary.js's registrationMessage namespace.
import Text from 'components/Text/Text';
import { tuple } from 'antd/lib/_util/type';

export default class RegistrationMessage extends React.Component {

  componentDidMount() {
    this.getIpAddress();
  }

  getIpAddress = async (ev) => {

    this.setState({ isLoading: true });
    try {
      const response = await _authService.getClientIP();
      if (response) {
        this.setState({ isLoading: false })
      }
      else {
        this.props.history.push(routes.home.basePath)
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render() {
    return (
      // Phase C.7.4C (§11.3 confirmation container / §12 Application ID prominence): removed the
      // `height: '100vh'` inline style that forced this page to occupy the full viewport height
      // regardless of content — with the header/toolbar sitting above it, that pushed the actual
      // confirmation card far down the page and created a large empty gap live-confirmed to match
      // this phase's own "unnecessarily large... unnecessary vertical scrolling" finding. The card
      // now sits close to the header with comfortable, not excessive, padding.
      <div className="d-flex ml-3 mr-3 registration-message">
        <div className="position-relative w-100 align-items-center m-auto  form-wrap d-flex align-items-center justify-content-center">
          <div className="d-flex align-items-center justify-items-center flex-column registration-message-card p-4">
            {/* Phase C.7.2 (Branding Foundation): was a hardcoded env-config PROJECT_LOGO, bypassing
                any admin-configured Portal_Logo/branding entirely — now resolved through the same
                priority chain as every other candidate surface. */}
            <img alt="PROJECT_LOGO" src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)} className="mb-4 mt-3 projectLogoSizeWidth" />

            <div className='displayInGrid mb-3 text-center'>
              <span className='color-secondary' ><Text k="registrationMessage.thankYouRegistration" /></span>
            </div>

            {/* Phase C.7.4C (§12): the Application ID is the single most important piece of
                information on this page — was a plain, unstyled inline span (`.color-highlight` had
                no CSS rule defined anywhere, confirmed by search) making the actual ID no more
                prominent than surrounding text. Restructured into a labeled callout with the ID as
                a large, bold, primary-colour value — same underlying value
                (`this.props.location.state.applicationID`), same source, nothing hardcoded or
                regenerated. */}
            <div className='registration-message-id w-100 text-center p-3  mb-3'>
              <div className="ent-application-id-label"><Text k="registrationMessage.applicationIdLabel" /></div>
              <div className="id ent-application-id-value">{this.props.location.state ? this.props.location.state.applicationID : ""}</div>
            </div>

            <div className="forget-sec w-90 text-center  ">
              <div className='displayInGrid mb-3'>
                <p className="text-left pt-2 color-secondary mb0 text-center" ><Text k="registrationMessage.loginInstruction" /></p>
              </div>
              <Button
                onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.login.path) }}
                className="button-global button-border autoHeight btn-100"
                value={<div className='displayInGrid'><Text k="registrationMessage.backToLoginButton" /></div>}
              ></Button>
            </div>
          </div>
        </div>
      </div >
    );
  }
}